import React from 'react';
import { Button, Container, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

const Expenses = () => {
    return (
        <Container>
            <Stack spacing={2} alignItems='center'>
                <Button size='large' variant='contained' color='primary' component={Link} to='/ConstructionExpenses'> Foundation Expenses </Button>
                <Button size='large' variant='contained' color='primary' component={Link} to='/DHQexpenses'> DHQ Expenses </Button>
            </Stack>
        </Container>
    );
};

export default Expenses;